import { PlayerApi } from "../common/atsApi";

class PlannedTournamentApi {
  constructor() {
    this.api = new PlayerApi("planned-tournament");
  }

  getStaticData = () => this.api.getRequest("static-data");

  getAll = () => this.api.getRequest("");
  getOne = (plannedTournamentId) => this.api.getRequest(`${plannedTournamentId}`);
  setOne = (plannedTournament) => this.api.postRequest("", plannedTournament);
  deleteOne = (plannedTournamentId) =>
    this.api.deleteRequest(`${plannedTournamentId}`, { 400: "Cannot delete tournament with active registrations, please delete registrations first." });

  copy = (plannedTournamentId) => this.api.postRequest(`${plannedTournamentId}/copy`);

  openRegistration = (plannedTournamentId) => this.api.postRequest(`${plannedTournamentId}/open`);
  closeRegistration = (plannedTournamentId) => this.api.postRequest(`${plannedTournamentId}/close`);
  unregister = (plannedTournamentId, plannedEventRegistrationId) => this.api.postRequest(`${plannedTournamentId}/unregister/${plannedEventRegistrationId}`);
  makeEven = (plannedTournamentId) => this.api.postRequest(`${plannedTournamentId}/even`);
  setTier = (plannedTournamentId, plannedEventRegistrationId, tierId) =>
    this.api.postRequest(`${plannedTournamentId}/set-tier/${plannedEventRegistrationId}/${tierId}`);

  start = (plannedTournamentId) => this.api.postRequest(`${plannedTournamentId}/start`, { 400: "Event with the same name already exists." });
}

export default new PlannedTournamentApi();
